<script setup lang="ts">
import { useUi } from '@/stores/ui';
import Icon from './Icon.vue';

const ui = useUi();
const ICON = { success: 'check', danger: 'alert', info: 'info', warning: 'alert' } as const;
</script>

<template>
  <Teleport to="body">
    <div class="toasts">
      <TransitionGroup name="toast">
        <div v-for="t in ui.toasts" :key="t.id" class="toast" :class="`toast--${t.tone}`" @click="ui.dismiss(t.id)">
          <span class="ico"><Icon :name="ICON[t.tone]" :size="15" :stroke="2.2" /></span>
          <div class="grow">
            <div class="title">{{ t.title }}</div>
            <div v-if="t.text" class="text">{{ t.text }}</div>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toasts {
  position: fixed;
  right: 18px;
  bottom: 18px;
  z-index: 300;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: min(380px, calc(100vw - 36px));
}
.toast {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 11px 13px;
  background: var(--surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
  cursor: pointer;
}
.ico {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
}
.toast--success .ico {
  background: var(--success-soft);
  color: var(--success);
}
.toast--danger .ico {
  background: var(--danger-soft);
  color: var(--danger);
}
.toast--info .ico {
  background: var(--info-soft);
  color: var(--info);
}
.toast--warning .ico {
  background: var(--warning-soft);
  color: var(--warning);
}
.title {
  font-weight: 500;
}
.text {
  color: var(--muted);
  font-size: 12.5px;
  margin-top: 2px;
}
.toast-enter-active,
.toast-leave-active {
  transition: all 200ms var(--ease);
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(16px);
}
</style>
